import { h, render } from "preact";
import { Provider } from "react-redux";

import Routes from "../routes";
import store, {
  setCompany,
  setFeatures,
  setPreviewMode,
  setTasks,
  setUser,
} from "../store/index";

export default function initReactApp() {
  const rootElement = document.getElementById("react-app");
  if (rootElement) {
    store.dispatch(setFeatures((window.__preloadState || {}).features));
    store.dispatch(setPreviewMode((window.__preloadState || {}).previewMode));
    store.dispatch(setUser((window.__preloadState || {}).currentUser));
    store.dispatch(setTasks((window.__preloadState || {}).tasks));
    store.dispatch(setCompany((window.__preloadState || {}).company));

    render(
      <Provider store={store}>
        <Routes />
      </Provider>,
      rootElement
    );
  }
}
